import React, { useState } from 'react';
import { FilterXIcon } from 'lucide-react';
import { categoryLabels, events, quarterLabels, type EventCategory } from './gameTimelineData';
import { categoryChipClasses, categoryIcon, teamAccent } from './gameTimelineIcons';
const CATEGORIES: EventCategory[] = ['injury', 'foul', 'general', 'turnover', 'point', 'timeout'];
const FILTER_LABELS: Record<EventCategory, string> = {
  injury: 'Injuries',
  foul: 'Fouls',
  general: 'General',
  turnover: 'Turnovers',
  point: 'Points',
  timeout: 'Timeouts'
};
const QUARTERS: Array<'Q1' | 'Q2' | 'Q3' | 'Q4'> = ['Q1', 'Q2', 'Q3', 'Q4'];
export const FullTimeline = () => {
  const [active, setActive] = useState<EventCategory[]>(CATEGORIES);
  const toggle = (category: EventCategory) => setActive(prev => prev.includes(category) ? prev.filter(item => item !== category) : [...prev, category]);
  const visible = events.filter(event => active.includes(event.category));
  return <div data-id="element-82" data-mp="19h6gtcz1k498">
      {/* Filters */}
      <div className="flex flex-wrap items-center gap-2 mb-6" data-id="element-83" data-mp="19hznkdy02trd">
        <span className="text-sm font-medium text-gray-700 mr-1" data-id="element-84" data-mp="1eeq6ra53q5h0">
          Event types
        </span>
        {CATEGORIES.map(category => {
        const isActive = active.includes(category);
        return <button key={category} type="button" onClick={() => toggle(category)} aria-pressed={isActive} className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-full border transition-colors ${isActive ? categoryChipClasses[category] : 'bg-white border-gray-200 text-gray-400 hover:text-gray-600'}`} data-id="element-85" data-mp="1o62vvtzimhjc">
              {categoryIcon(category)}
              {FILTER_LABELS[category]}
            </button>;
      })}
        <button type="button" onClick={() => setActive(CATEGORIES)} className="ml-auto flex items-center px-3 py-1.5 text-sm font-medium text-gray-600 hover:text-gray-900" data-id="element-86" data-mp="cqxhvttxowkf">
          <FilterXIcon className="w-4 h-4 mr-1.5" data-id="element-87" data-mp="po1ciwv953g" />
          Show all
        </button>
      </div>

      {active.length === 0 ? <div className="border border-dashed border-gray-300 rounded-lg py-12 text-center" data-id="element-88" data-mp="9oj9i0jh0p9e">
          <p className="font-medium text-gray-700" data-id="element-89" data-mp="9qvwis435ptb">No event types selected</p>
          <p className="text-sm text-gray-500 mt-1" data-id="element-90" data-mp="nmhnh4tvqjod">
            Turn on at least one filter to see the timeline.
          </p>
        </div> : <div className="space-y-8" data-id="element-91" data-mp="xedk0bgbi1qh">
          {QUARTERS.map(quarter => {
        const quarterEvents = visible.filter(event => event.quarter === quarter);
        return <section key={quarter} data-id="element-92" data-mp="17dcrhqpcjrbw">
                <h3 className="text-lg font-semibold mb-4" data-id="element-93" data-mp="17a71m98w8lf4">
                  {quarterLabels[quarter]}
                </h3>
                {quarterEvents.length === 0 ? <p className="text-sm text-gray-500 pl-1" data-id="element-94" data-mp="1lzi7w8i7pa2o">
                    No matching events in this quarter.
                  </p> : <ol className="space-y-4" data-id="element-95" data-mp="1c1c9i0vm6m2k">
                    {quarterEvents.map(event => {
              const accent = teamAccent(event.team);
              return <li key={event.id} className="flex" data-id="element-96" data-mp="12ahlos2pzef0">
                          <div className="flex-shrink-0 w-16 text-sm font-medium text-gray-500 pt-0.5" data-id="element-97" data-mp="128wqd08kzrg3">
                            {event.time}
                          </div>
                          <div className={`flex-shrink-0 w-7 h-7 rounded-full border flex items-center justify-center mr-3 ${accent.soft} ${accent.border} ${accent.text}`} title={categoryLabels[event.category]} data-id="element-98" data-mp="tbw7f94a6lk1">
                            {categoryIcon(event.category, 'w-4 h-4')}
                          </div>
                          <div className={`flex-grow border-l-2 pl-3 pb-4 ${accent.border}`} data-id="element-99" data-mp="1rkui265qo4mj">
                            <div className="flex flex-wrap items-center gap-2" data-id="element-100" data-mp="1hw2ro2gbtsdq">
                              <span className="font-medium text-gray-900" data-id="element-101" data-mp="1htzqqndmyeu8">
                                {event.event}
                                {event.player && ` — ${event.player}`}
                              </span>
                              <span className={`text-[11px] uppercase tracking-wide px-2 py-0.5 rounded-full border ${categoryChipClasses[event.category]}`} data-id="element-102" data-mp="13w1ryqbssqzu">
                                {categoryLabels[event.category]}
                              </span>
                              {event.score && <span className="text-xs font-semibold text-gray-500" data-id="element-103" data-mp="2t957gvalqdwu">
                                  {event.score}
                                </span>}
                            </div>
                            <div className="text-sm text-gray-600 mt-1" data-id="element-104" data-mp="30u8qv7suckb7">
                              {event.detail}
                            </div>
                          </div>
                        </li>;
            })}
                  </ol>}
              </section>;
      })}
        </div>}
    </div>;
};
export default FullTimeline;